
        import {css} from 'lit-element';   
        export default css`.pagination_main{justify-content:center;display:flex;flex-direction:row;align-items:center}.search_prev,.search_next{padding:1px 12px 0px 12px}.pagination_textfield{width:var(--spectrum-global-dimension-size-200);display:inline-flex;position:relative;padding-right:4px}.cursor_enabled{cursor:pointer}`;
    